/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEstimatedLaborCost } from '../fn/estimated-labor-cost/create-estimated-labor-cost';
import { CreateEstimatedLaborCost$Params } from '../fn/estimated-labor-cost/create-estimated-labor-cost';
import { deleteEstimatedLaborCost } from '../fn/estimated-labor-cost/delete-estimated-labor-cost';
import { DeleteEstimatedLaborCost$Params } from '../fn/estimated-labor-cost/delete-estimated-labor-cost';
import { EstimatedDailyLaborCostDtoPage } from '../models/estimated-daily-labor-cost-dto-page';
import { EstimatedLaborCostDto } from '../models/estimated-labor-cost-dto';
import { EstimatedLaborCostDtoPage } from '../models/estimated-labor-cost-dto-page';
import { getEstimatedLaborCost } from '../fn/estimated-labor-cost/get-estimated-labor-cost';
import { GetEstimatedLaborCost$Params } from '../fn/estimated-labor-cost/get-estimated-labor-cost';
import { listEstimatedDailyLaborCosts } from '../fn/estimated-labor-cost/list-estimated-daily-labor-costs';
import { ListEstimatedDailyLaborCosts$Params } from '../fn/estimated-labor-cost/list-estimated-daily-labor-costs';
import { listEstimatedLaborCosts } from '../fn/estimated-labor-cost/list-estimated-labor-costs';
import { ListEstimatedLaborCosts$Params } from '../fn/estimated-labor-cost/list-estimated-labor-costs';
import { previewEstimatedLaborCost } from '../fn/estimated-labor-cost/preview-estimated-labor-cost';
import { PreviewEstimatedLaborCost$Params } from '../fn/estimated-labor-cost/preview-estimated-labor-cost';
import { PreviewEstimatedLaborCostDto } from '../models/preview-estimated-labor-cost-dto';
import { updateEstimatedLaborCost } from '../fn/estimated-labor-cost/update-estimated-labor-cost';
import { UpdateEstimatedLaborCost$Params } from '../fn/estimated-labor-cost/update-estimated-labor-cost';

@Injectable({ providedIn: 'root' })
export class EstimatedLaborCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEstimatedLaborCosts()` */
  static readonly ListEstimatedLaborCostsPath = '/v0/estimatedLaborCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEstimatedLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedLaborCosts$Response(params?: ListEstimatedLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedLaborCostDtoPage>> {
    return listEstimatedLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEstimatedLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedLaborCosts(params?: ListEstimatedLaborCosts$Params, context?: HttpContext): Observable<EstimatedLaborCostDtoPage> {
    return this.listEstimatedLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedLaborCostDtoPage>): EstimatedLaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `createEstimatedLaborCost()` */
  static readonly CreateEstimatedLaborCostPath = '/v0/estimatedLaborCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEstimatedLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedLaborCost$Response(params: CreateEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEstimatedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEstimatedLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedLaborCost(params: CreateEstimatedLaborCost$Params, context?: HttpContext): Observable<string> {
    return this.createEstimatedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listEstimatedDailyLaborCosts()` */
  static readonly ListEstimatedDailyLaborCostsPath = '/v0/estimatedLaborCost/daily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEstimatedDailyLaborCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedDailyLaborCosts$Response(params?: ListEstimatedDailyLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedDailyLaborCostDtoPage>> {
    return listEstimatedDailyLaborCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEstimatedDailyLaborCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedDailyLaborCosts(params?: ListEstimatedDailyLaborCosts$Params, context?: HttpContext): Observable<EstimatedDailyLaborCostDtoPage> {
    return this.listEstimatedDailyLaborCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedDailyLaborCostDtoPage>): EstimatedDailyLaborCostDtoPage => r.body)
    );
  }

  /** Path part for operation `getEstimatedLaborCost()` */
  static readonly GetEstimatedLaborCostPath = '/v0/estimatedLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstimatedLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedLaborCost$Response(params: GetEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedLaborCostDto>> {
    return getEstimatedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEstimatedLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedLaborCost(params: GetEstimatedLaborCost$Params, context?: HttpContext): Observable<EstimatedLaborCostDto> {
    return this.getEstimatedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedLaborCostDto>): EstimatedLaborCostDto => r.body)
    );
  }

  /** Path part for operation `updateEstimatedLaborCost()` */
  static readonly UpdateEstimatedLaborCostPath = '/v0/estimatedLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEstimatedLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedLaborCost$Response(params: UpdateEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return updateEstimatedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEstimatedLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedLaborCost(params: UpdateEstimatedLaborCost$Params, context?: HttpContext): Observable<string> {
    return this.updateEstimatedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `deleteEstimatedLaborCost()` */
  static readonly DeleteEstimatedLaborCostPath = '/v0/estimatedLaborCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEstimatedLaborCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedLaborCost$Response(params: DeleteEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEstimatedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEstimatedLaborCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedLaborCost(params: DeleteEstimatedLaborCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteEstimatedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `previewEstimatedLaborCost()` */
  static readonly PreviewEstimatedLaborCostPath = '/v0/estimatedLaborCost/preview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewEstimatedLaborCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  previewEstimatedLaborCost$Response(params: PreviewEstimatedLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PreviewEstimatedLaborCostDto>> {
    return previewEstimatedLaborCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `previewEstimatedLaborCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  previewEstimatedLaborCost(params: PreviewEstimatedLaborCost$Params, context?: HttpContext): Observable<PreviewEstimatedLaborCostDto> {
    return this.previewEstimatedLaborCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PreviewEstimatedLaborCostDto>): PreviewEstimatedLaborCostDto => r.body)
    );
  }

}
